function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_20040071_99328)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_bd_20040071_99328)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  rx: 4,
  fill: "url(#paint0_linear_20040071_99328)"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.0223 23.4668C6.89861 23.4668 3.55566 20.1239 3.55566 16.0001C3.55566 11.8764 6.89861 8.53346 11.0223 8.53346L20.9779 8.53346C25.1016 8.53346 28.4446 11.8764 28.4446 16.0001C28.4446 20.1239 25.1016 23.4668 20.9779 23.4668H11.0223ZM20.3557 20.9779C23.1048 20.9779 25.3334 18.7493 25.3334 16.0001C25.3334 13.251 23.1048 11.0223 20.3557 11.0223L11.6446 11.0223C8.8954 11.0223 6.66678 13.251 6.66678 16.0001C6.66678 18.7493 8.8954 20.9779 11.6446 20.9779H20.3557Z",
  fill: "url(#paint1_linear_20040071_99328)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.5332 11.0223C8.5332 6.89861 11.8761 3.55566 15.9999 3.55566C20.1236 3.55566 23.4665 6.89861 23.4665 11.0223V20.9779C23.4665 25.1016 20.1236 28.4446 15.9999 28.4446C11.8761 28.4446 8.5332 25.1016 8.5332 20.9779V11.0223ZM11.0221 20.3557C11.0221 23.1048 13.2507 25.3334 15.9999 25.3334C18.749 25.3334 20.9777 23.1048 20.9777 20.3557V11.6446C20.9777 8.8954 18.749 6.66678 15.9999 6.66678C13.2507 6.66678 11.0221 8.8954 11.0221 11.6446V20.3557Z",
  fill: "url(#paint2_linear_20040071_99328)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_bd_20040071_99328",
  x: -14.4792,
  y: -14.4792,
  width: 64.9583,
  height: 64.9583,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 7.23958
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_20040071_99328"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3.61979
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3.61979
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_backgroundBlur_20040071_99328",
  result: "effect2_dropShadow_20040071_99328"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow_20040071_99328",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_20040071_99328",
  x1: 0,
  y1: 0,
  x2: 40.7965,
  y2: 6.67223,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.323628,
  stopColor: "#3738B8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ED4F9D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_20040071_99328",
  x1: 8.44455,
  y1: 12.4444,
  x2: 26.9579,
  y2: 25.2589,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6A6A6A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_20040071_99328",
  x1: 15.9998,
  y1: 12.7736,
  x2: 14.4425,
  y2: 28.7254,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6A6A6A"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_20040071_99328"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  rx: 16,
  fill: "white"
})));

function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.debbb193dc0662c22fe716961ceaea54.svg";
export { ForwardRef as ReactComponent };